import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { getAgencySubagencyData } from "../../../api/fedRamp";
import { GENERIC_ERROR_STRING } from "../../../constants";

/**
 * FedRamp Agency Authorization Modal
 * @param {Object} props
 * @param {number} props.productSeq
 * @param {string} props.productName
 * @param {function} props.closeModal
 * @returns {Element}
 * @constructor
 */
export default function AgencyAuthorization({ productSeq, productName, closeModal }) {
  const [agencySubAgencies, setAgencySubAgencies] = useState(/** @type {FedRampAgencySubAgencyModel[]} */[]);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAgencySubagencyData(productSeq).then(({ data }) => {
      setAgencySubAgencies(data);
    }).catch(error => {
      setError(error);
    });
  }, [productSeq]);

  let modalContent;

  if (error) {
    modalContent = <p>{GENERIC_ERROR_STRING}</p>;
  } else if (!agencySubAgencies) {
    modalContent = <p>Loading Agency Authorization details</p>;
  } else {
    modalContent = <>
      List of Agencies/Subagencies for <strong>{productName}</strong>
      <ol>
        {agencySubAgencies.map(
          (agencySubagency) => (<li key={agencySubagency.agencyName} className="fedramp-list-item-space-after">
            {agencySubagency.agencyName}
            {agencySubagency.subagencyNames.length > 1 && <ul>
              {agencySubagency.subagencyNames.filter((subagencyName) => subagencyName !== null)
                              .map((subagencyName) => (<li key={subagencyName}>{subagencyName}</li>))}
            </ul>}
          </li>))}
      </ol>
    </>;
  }

  return (<Dialog open={true} onClose={closeModal}>
    <DialogTitle sx={{ m: 0, p: 2, color: "white", backgroundColor: "#2D5986", padding: "8px 16px" }}>
      Agencies Authorizations
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={closeModal}
      sx={{
        position: "absolute", right: 0, top: 0, color: "white",
      }}
    >
      <CloseIcon/>
    </IconButton>
    <DialogContent>
      {modalContent}
    </DialogContent>
  </Dialog>);
}

AgencyAuthorization.propTypes = {
  productSeq: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};